<template>
  <focus-page :title="title">
    <wo-alert v-if="error" mod-error><span v-t="'signin.error.credentials'"></span></wo-alert>
    <wo-alert v-if="signOut && !error"><span v-t="'signin.signedOut'"></span></wo-alert>
    <form>
      <wo-label for="email" v-t="'form.email.label'"></wo-label>
      <wo-input-field id="email" mod-block :placeholder="$t('form.email.placeholder')" v-model="credentials.email" autocomplete="email username" v-focus="true" />
      <wo-grid>
        <wo-column width="6">
          <wo-label for="password" v-t="'form.password.label'"></wo-label>
        </wo-column>
        <wo-column width="6" v-wo-align:right>
          <po-route-link :value="resetRoute" label-key="signin.forgotPassword" tabindex="-1" />
        </wo-column>
      </wo-grid>
      <wo-input-field id="password" mod-block :placeholder="$t('form.password.placeholder')" type="password" autocomplete="current-password" v-model="credentials.password" />
      <wo-grid mod-stacked>
        <wo-column width="6" />
        <wo-column width="6" v-wo-v-align:center v-wo-align:right>
          <po-promise-button :disabled="!valid" label-key="signin.action.confirm" @click="signIn" type="submit" />
        </wo-column>
      </wo-grid>
    </form>
    <account-focus-footer slot="footer" />
  </focus-page>
</template>

<script>

import { mapState } from 'vuex'

import FocusPage from '@/components/layout/FocusPage'
import AccountFocusFooter from '@/components/identity/AccountFocusFooter'

import { DASHBOARD } from '@/routes/general'
import { RESET_PASSWORD_REQUEST } from '@/routes/identity'
import { signOut, authRepository } from '@/repository/identity'

export default {
  components: { FocusPage, AccountFocusFooter },
  props: {
    signOut: Boolean
  },
  data () {
    return {
      error: false,
      credentials: {
        email: undefined,
        password: undefined
      }
    }
  },
  computed: mapState({
    env: state => state.environment.current,
    valid () {
      return this.credentials.email && this.credentials.password
    },
    title () {
      return this.$t('signin.title', { appName: this.$t(this.env.appTitleKey) })
    },
    resetRoute () { return RESET_PASSWORD_REQUEST }
  }),
  created () {
    if (this.signOut) {
      signOut(this.$store)
    }
  },
  methods: {
    signIn ({ detail }) {
      this.$store.dispatch(authRepository.create, { entity: this.credentials })
        .then(this.loginSuccess, this.loginFailure)
        .finally(detail.resolve)
    },
    loginSuccess () {
      this.error = false
      this.$router.push({ name: DASHBOARD })
    },
    loginFailure () {
      this.error = true
    }
  }
}
</script>
